import React from 'react';
import { motion } from "framer-motion";
import logo from './logo512.png';

function Loader(props) {
    return (
        <div className="loader loader-dateset-main flex-column">
            <motion.div
                animate={{ rotate: 360 }}
                transition={{
                    type: "spring",
                    stiffness: 260,
                    damping: 20,
                    repeat: Infinity
                }}
            >
                <img src={logo} alt="stc loader" />
            </motion.div>
            {props.text && <h4 className='p-4'>{props.text}</h4>}
        </div>
    );
}

export default Loader;